/**
 * Slide-image URL for a post_assets row returned by the list API
 * (image_assets / detail assets) — public_url for B2-backed projects,
 * the api asset route for local disk. Same derivation as PostDetail.
 */
export function assetUrl(postId, a) {
  const filename = (a.local_path || '').split('/').pop()
    || `${String(a.ordinal ?? 0).padStart(2, '0')}.png`;
  const base = a.public_url || `/api/posts/${postId}/assets/${filename}`;
  return `${base}?v=${a.created_at || ''}`;
}
